import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {MentalBackground} from "./background/MentalBackground";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {MentalGameAssets} from "./MentalGameAssets";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {ReelStartPresentation} from "./flowStatePresentations/ReelStartPresentation";
import {BaseGameIdlePresentation} from "./flowStatePresentations/baseGame/BaseGameIdlePresentation";
import {MentalWinPresentation} from "./winPresentations/MentalWinPresentation";
import {ReelStopPresentation} from "./flowStatePresentations/ReelStopPresentation";
import {FreeGameIdlePresentation} from "./flowStatePresentations/freeGame/FreeGameIdlePresentation";
import {GraphicsPool} from "./utils/GraphicsPool";
import {MentalModel} from "./server/MentalModel";
import {MentalReelAreaView} from "./reel/MentalReelAreaView";
import {MentalGameMode} from "./server/MentalGameMode";
import {MentalFsIntro} from "./winPresentations/introOutro/MentalFsIntro";
import {MentalFsOutro} from "./winPresentations/introOutro/MentalFsOutro";
import {MentalStickyScatter} from "./features/MentalStickyScatter";
import {MentalFireFrame} from "./features/MentalFireFrame";
import {EnhancerReelPresentation} from "./winPresentations/enhancerReel/EnhancerReelPresentation";
import {MentalInitialWinPresentation} from "./winPresentations/initialWin/MentalInitialWinPresentation";
import {IWinRatios, WinRatioType} from "../framework/winPresentation/IWinRatios";
import {MentalDeadFeature} from "./winPresentations/deadFeature/MentalDeadFeature";
import {XNudgePresentation} from "./winPresentations/xFeature/XNudgePresentation";
import {BowlbyOneSC, Titania, VeteranTypewriter} from "./Fonts";
import {BigWin} from "./winPresentations/bigWinPresentation/BigWin";
import {XWaysCounter} from "./features/XWaysCounter";
import {MentalDeadStickyMultiplier} from "./features/MentalDeadStickyMultiplier";
import {MentalWinWaysView} from "./features/MentalWinWaysView";
import {MentalWinHighlightView} from "./features/MentalWinHighlightView";
import {MentalXSplitAnimationsView} from "./features/MentalXSplitAnimationsView";
import {S2XWaysFeature} from "./features/S2XWaysFeature";
import {MentalEnhancerFrame} from "./features/MentalEnhancerFrame";
import {SoundManager} from "./sound/SoundManager";
import {MentalSoundConfig} from "./MentalSoundConfig";
import {MentalWinCapView} from "./features/MentalWinCapView";
import {ScatterAnticipationView} from "./reel/scatterAnticipationView";
import {MentalPlusOneTextView} from "./features/MentalPlusOneTextView";
import {MentalBigWinAnticipationView} from "./features/MentalBigWinAnticipationView";
import {MentalFeatureIndicatorView} from "./features/MentalFeatureIndicatorView";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {JurisdictionNames} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/GameClientConfiguration";
import {RandomFeatureBuy} from "./features/RandomFeatureBuy";
import {Skinner} from "@nolimitcity/slot-launcher/bin/utils/Skinner";

export class Mental extends SlotGame {
    // #144
    public static timeSegment: number = 0.8;

    public static background: MentalBackground;
    public static model: MentalModel;
    public static assetLoader: AssetLoader;
    public static gameFlowController: GameFlowController;
    public static graphicsPool: GraphicsPool;
    public static reelArea: MentalReelAreaView;
    // introOutro
    public static fsIntro: MentalFsIntro;
    public static fsOutro: MentalFsOutro;
    // sticky scatter
    public static stickyScatter: MentalStickyScatter;
    //fireframe
    public static fireFrame: MentalFireFrame;
    //scatter anticipation
    public static scatterAnticipation: ScatterAnticipationView;
    // Enhancer reels
    public static enhancerReelPresentation: EnhancerReelPresentation;
    // Win Presentations
    public static initialWinPresentation: MentalInitialWinPresentation;
    // xnudge Presentation
    public static xNudgePresentation: XNudgePresentation;
    // dead Feature Presentation
    public static deadFeaturePresentation: MentalDeadFeature;
    // s2 xways feature
    public static s2xWaysFeature: S2XWaysFeature;
    // bigWin
    public static bigWinPresentation: BigWin;
    //x-ways counter
    public static xWaysCounter: XWaysCounter;
    // dead Feature sticky Multiplier
    public static deadFeatureStickyMultiplier: MentalDeadStickyMultiplier;

    // win ways for initial win and toggle win
    public static winWays: MentalWinWaysView;

    // win highlight for initial win and toggle win
    public static winHighlight: MentalWinHighlightView;

    // xSplit animations -> blood and knife animation
    public static xSplitAnimations: MentalXSplitAnimationsView;

    // enhancerFrame
    public static enhancerFrame: MentalEnhancerFrame;

    public static winCap: MentalWinCapView;

    // #154
    public static plusOneText: MentalPlusOneTextView;

    public static randomFeatureBuy: RandomFeatureBuy;

    // #366
    public static isBigWinAnticipation: boolean = false;

    // #321
    public static isSoftWinCap: boolean = false;

    // #148
    public static specialDeadMultiplierReveal: number = -1;
    public static specialDeadMultiplierRevealWin: boolean = false;

    public static WIN_RATIOS: IWinRatios = {
        normalWin: [
            {
                ratio: 0,
                text: "Tiny Win",
                duration: 0.001,
                type: WinRatioType.TINY
            },
            {
                ratio: 1.5,
                text: "Small Win",
                duration: 0.001,
                type: WinRatioType.SMALL
            },
            {
                ratio: 3,
                text: "Medium Win",
                duration: 0.5,
                type: WinRatioType.MEDIUM
            },
            {
                ratio: 5,
                text: "Large Win",
                duration: 1,
                type: WinRatioType.LARGE
            }
        ],
        bigWin: [
            {
                ratio: 15,
                text: "Level_1",
                duration: 4,
                type: WinRatioType.BIG_WIN
            },
            {
                ratio: 25,
                text: "Level_2",
                duration: 3.5334,
                type: WinRatioType.MEGA_WIN
            },
            {
                ratio: 50,
                text: "Level_3",
                duration: 3.5334,
                type: WinRatioType.SUPER_MEGA_WIN
            },
            {
                ratio: 100,
                text: "Level_4",
                duration: 3.5334,
                type: WinRatioType.SUPER_SUPER_MEGA_WIN
            },
            {
                ratio: 250,
                text: "Level_5",
                duration: 3.4334,
                type: WinRatioType.SUPER_DUPER_MEGA_WIN
            }
        ]
    };

    public static LAYERS = {
        WIN_CAP: "WIN_CAP",
        WIN_WAYS: "winWays",
        BIG_WIN: "BIGWIN",
        BIG_WIN_ANTICIPATION: "BIG_WIN_ANTICIPATION",
        WIN_PRESENTAION: "WIN_PRESENTAION",
        STICKY_WILD: "STICKY_WILD",
        FREESPIN_OUTRO: "FREESPIN_OUTRO",
        FREESPIN_INTRO: "FREESPIN_INTRO",
        SPEED_STER: "SPEED_STER",
        WIN_HIGHLIGHT: "winHighlight",
        X_SPLIT: "xSplit",
        ENHANCER_FRAME: "ENHANCER_FRAME",
        SCATTER_ANTICIPATION: "SCATTER_ANTICIPATION",
        FEATURE_INDICATOR: "featureIndicator",
        BACKGROUND: "BACKGROUND",
        PLUS_ONE_TEXT: "plusOneText",
        RANDOM_FEATUREE_BUY: "RANDOM_FEATUREE_BUY",
        X_WAYS_COUNTER: "X_WAYS_COUNTER",
        ENHANCER: "ENHANCER",
        WILD_DROP: "WILD_DROP",
        S2_XWAYS: "S2_XWAYS",
        X_NUDGE: "X_NUDGE",
        DEAD_SYM_ANIMS: "DEAD_SYM_ANIMS",
        DEAD_TO_ACTIVE: "DEAD_TO_ACTIVE"
    };
    private static skinner:Skinner;


    constructor() {
        super();
        const validSkinIds:string[] = [
            "ug",
            "ozzo",
            "1xbet",
            "test",
            "okgames",
            "playtime",
            "us-nonfree"
        ]
        Mental.skinner = new Skinner(validSkinIds);
    }

    private handleSkinInit(){
        if (Mental.apiPlugin.gameClientConfiguration.isSet) {
            if (Mental.apiPlugin.gameClientConfiguration.replaceWordFree){
                Mental.skinner.skinId = "us-nonfree";
            }
        } else {
            Mental.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (Mental.apiPlugin.gameClientConfiguration.replaceWordFree){
                    Mental.skinner.skinId = "us-nonfree";
                }
            })
        }
    }

    /**
     * initialize all the view And components here
     */
    private static initialization(): void {
        Mental.background = new MentalBackground();
        Mental.graphicsPool = new GraphicsPool();
        Mental.reelArea = new MentalReelAreaView();
        Mental.fsOutro = new MentalFsOutro();
        Mental.fsIntro = new MentalFsIntro();
        Mental.stickyScatter = new MentalStickyScatter();
        Mental.fireFrame = new MentalFireFrame();
        Mental.scatterAnticipation = new ScatterAnticipationView();
        Mental.xSplitAnimations = new MentalXSplitAnimationsView();
        Mental.enhancerReelPresentation = new EnhancerReelPresentation();
        Mental.initialWinPresentation = new MentalInitialWinPresentation();
        Mental.deadFeaturePresentation = new MentalDeadFeature();
        Mental.s2xWaysFeature = new S2XWaysFeature();
        Mental.bigWinPresentation = new BigWin();
        Mental.xWaysCounter = new XWaysCounter();
        Mental.deadFeatureStickyMultiplier = new MentalDeadStickyMultiplier();
        Mental.winWays = new MentalWinWaysView();
        Mental.winHighlight = new MentalWinHighlightView();
        Mental.enhancerFrame = new MentalEnhancerFrame();
        Mental.winCap = new MentalWinCapView();
        Mental.plusOneText = new MentalPlusOneTextView();
        Mental.randomFeatureBuy = new RandomFeatureBuy();
    }

    /**
     * add all the view on stage from here
     */
    private static addViewsOnStage(): void {
        NolimitApplication.addLayerAt(Mental.LAYERS.WIN_CAP, Mental.winCap, 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.FREESPIN_OUTRO, Mental.fsOutro, 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.FREESPIN_INTRO, Mental.fsIntro, 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.BIG_WIN, Mental.bigWinPresentation, 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.SPEED_STER, new PIXI.Container(), 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.WIN_WAYS, Mental.winWays, 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.WIN_PRESENTAION, Mental.initialWinPresentation, 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.STICKY_WILD, Mental.fsOutro, 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.RANDOM_FEATUREE_BUY, Mental.randomFeatureBuy, 0); // randomFeatureBuy
        NolimitApplication.addLayerAt(Mental.LAYERS.PLUS_ONE_TEXT, Mental.plusOneText, 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.STICKY_WILD, Mental.fireFrame, 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.BIG_WIN_ANTICIPATION, new PIXI.Container(), 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.X_SPLIT, Mental.xSplitAnimations, 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.ENHANCER, Mental.enhancerReelPresentation, 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.S2_XWAYS, Mental.s2xWaysFeature, 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.X_WAYS_COUNTER, Mental.xWaysCounter, 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.WIN_HIGHLIGHT, Mental.winHighlight, 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.X_NUDGE, new PIXI.Container(), 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.DEAD_TO_ACTIVE, new PIXI.Container(), 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.DEAD_SYM_ANIMS, Mental.deadFeaturePresentation, 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.STICKY_WILD, Mental.deadFeatureStickyMultiplier, 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.SCATTER_ANTICIPATION, Mental.scatterAnticipation, 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.ENHANCER_FRAME, Mental.enhancerFrame, 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.FEATURE_INDICATOR, new PIXI.Container(), 0);
        NolimitApplication.addLayerAt(Mental.reelArea.name, Mental.reelArea, 0);
        NolimitApplication.addLayerAt(Mental.LAYERS.BACKGROUND, Mental.background, 0);

        Mental.xNudgePresentation = new XNudgePresentation(); // need access of X_NUDGE inside this

        MentalBigWinAnticipationView.createItems();
        MentalFeatureIndicatorView.createItems();

        Mental.deadFeaturePresentation.initDeadToActive();
    }

    // #321
    private static onGameClientConfigurationApplied(): void {
        const currentJurisdiction: string = Mental.apiPlugin.gameClientConfiguration.jurisdictionName,
            jurisdictionsWithSoftWinCap: string[] = [JurisdictionNames.ITALY];

        Mental.isSoftWinCap = (jurisdictionsWithSoftWinCap.includes(currentJurisdiction));
    }

    public start(): Promise<NolimitPlugin> {
        // User has pressed continue and the game starts.
        return super.start().then((value: NolimitPlugin) => {
            Mental.gameFlowController.start();
            return value;
        });
    }

    public init(): Promise<NolimitPlugin> {
        return super.init().then((value: NolimitPlugin) => {
            Mental.model = new MentalModel(SlotGame.apiPlugin);
            Mental.model.logger.level = LogLevel.DEV;
            Mental.gameFlowController = new GameFlowController(SlotGame.apiPlugin, Mental.model);
            Mental.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            // #321
            if (Mental.apiPlugin.gameClientConfiguration.isSet) {
                Mental.onGameClientConfigurationApplied();
            } else {
                Mental.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => Mental.onGameClientConfigurationApplied());
            }

            // IDLE & WIN
            const idlePresentation = new BaseGameIdlePresentation();
            const winPresentation = new MentalWinPresentation();

            //REEL SPIN & STOP
            const reelStartPresentation = new ReelStartPresentation();
            const reelStopPresentation = new ReelStopPresentation();

            // NORMAL MODE
            Mental.gameFlowController.addGameModeFlowStatePresentationMap(MentalGameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, idlePresentation],
                [FlowState.BET, reelStartPresentation],
                [FlowState.RESULT, reelStopPresentation],
                [FlowState.WIN, winPresentation]
            ]));

            // FREESPIN
            const fsidlePresentation = new FreeGameIdlePresentation();
            Mental.gameFlowController.addGameModeFlowStatePresentationMap(MentalGameMode.STANDARD_FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, fsidlePresentation],
                [FlowState.BET, reelStartPresentation],
                [FlowState.RESULT, reelStopPresentation],
                [FlowState.WIN, winPresentation]
            ]));
            Mental.gameFlowController.addGameModeFlowStatePresentationMap(MentalGameMode.COOL_FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, fsidlePresentation],
                [FlowState.BET, reelStartPresentation],
                [FlowState.RESULT, reelStopPresentation],
                [FlowState.WIN, winPresentation]
            ]));
            Mental.gameFlowController.addGameModeFlowStatePresentationMap(MentalGameMode.SUPER_FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, fsidlePresentation],
                [FlowState.BET, reelStartPresentation],
                [FlowState.RESULT, reelStopPresentation],
                [FlowState.WIN, winPresentation]
            ]));

            // #423
            Mental.apiPlugin.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE, (data: any) => {
                if (data) {
                    idlePresentation.stop();
                }
            });

            this.handleSkinInit();


            return value;
        });
    }

    public getReady(): Promise<NolimitPlugin> {
        return super.getReady().then((value: NolimitPlugin) => {
            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);
            fontLoader.add(BowlbyOneSC.REGULAR);
            fontLoader.add(VeteranTypewriter.REGULAR);
            fontLoader.add(Titania.REGULAR);
            AssetsConfig.addToAssetsConfig(MentalGameAssets.RESOURCES_GROUPS);
            Mental.assetLoader = new AssetLoader(Mental.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const promises = Promise.all([fontLoader.load(), Mental.assetLoader.load(ResourcesGroupName.MAIN)]);
            return promises.then(() => {

                if (Mental.skinner.skinId != undefined) {
                    //Source folder for skin assets e.g "resources/images/skinName";
                    const assetPath:string = "resources/images/";
                    const replaceMap:Map<string, string> = new Map();
                    if(Mental.skinner.skinId==="us-nonfree"){
                        replaceMap.set("FREESPIN", "FREESPIN.png");
                        replaceMap.set("FREESPIN_LEVEL_TWO", "FREESPIN_LEVEL_TWO.png");
                        replaceMap.set("FREESPIN_LEVEL_THREE", "FREESPIN_LEVEL_THREE.png");
                        replaceMap.set("FREESPIN_LEVEL_ONE", "FREESPIN_LEVEL_ONE.png");
                        replaceMap.set("freespin/assets_spine/horror-lift_0000s_0013_Mental-freespins", "horror-lift_0000s_0013_Mental-freespins.png");
                        replaceMap.set("freespin/assets_spine/horror-lift_0000s_0015_FREESPIN", "horror-lift_0000s_0015_FREESPIN.png");
                        replaceMap.set("freespin/assets_spine/horror-lift_0006_before-the--noise", "horror-lift_0006_before-the--noise.png");

                    }else {
                        replaceMap.set("logo", "introLogo.png");
                        replaceMap.set("feature1", "page1.png");
                        replaceMap.set("feature2", "page2.png");
                        replaceMap.set("S/1/S_spin", "S_spin.png");
                        replaceMap.set("S/scatter/s1_skull", "s1_skull.png");
                        replaceMap.set("S2/1/S2_spin", "S2_spin.png");
                        replaceMap.set("S2/scatter/s2_spider", "s2_spider.png");
                        replaceMap.set("FREESPIN", "FREESPIN.png");
                        replaceMap.set("FREESPIN_LEVEL_ONE", "FREESPIN_LEVEL_ONE.png");
                        replaceMap.set("FREESPIN_LEVEL_TWO", "FREESPIN_LEVEL_TWO.png");
                        replaceMap.set("FREESPIN_LEVEL_THREE", "FREESPIN_LEVEL_THREE.png");
                    }
                    return Mental.skinner.loadSkin( replaceMap).then(() => {
                        Mental.initialization();
                        Mental.addViewsOnStage();

                        return value
                    });
                } else {
                    Mental.initialization();
                    Mental.addViewsOnStage();
                    return value;
                }

            });
        });
    }

    public getReadyToStart(): Promise<NolimitPlugin> {
        SoundManager.playAmbientLoop(MentalSoundConfig.MAIN_GAME_AMBIANCE);
        return super.getReadyToStart();
    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "L4",
                    "L3",
                    "L5",
                    "M4",
                    "L2"
                ],
                [
                    "L3",
                    "L2",
                    "L4",
                    "M5",
                    "L1"
                ],
                [
                    "L2",
                    "L3",
                    "M4",
                    "L4",
                    "L1"
                ],
                [
                    "L5",
                    "L3",
                    "L2",
                    "L4",
                    "L1"
                ],
                [
                    "L2",
                    "L3",
                    "L4",
                    "L5",
                    "L2"
                ]
            ],
            "evaluatedArea": [
                [
                    "L3",
                    "L5",
                    "M4"
                ],
                [
                    "L2",
                    "L4",
                    "X"
                ],
                [
                    "L3",
                    "M4",
                    "L4"
                ],
                [
                    "L3",
                    "L2",
                    "X"
                ],
                [
                    "L3",
                    "L4",
                    "L5"
                ]
            ],
            "betWayWins": [],
            "totalBetWayWinnings": 0,
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 0.2,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "addedNumberOfFreespinsThisSpin": 0,
            "freespinTriggeredThisSpin": false,
            "scatterPositionsEnteringFreespin": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "doReelNudge": [
                false,
                false,
                false,
                false,
                false
            ],
            "multiplierOnReel": [
                0,
                0,
                0,
                0,
                0
            ],
            "scatter2Position": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "fireFrames": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    true,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "finalSymbolSize": [
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    2,
                    0
                ],
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    0
                ],
                [
                    1,
                    1,
                    1
                ]
            ],
            "scatter2Multiplier": [
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ]
            ],
            "specialReelsOpen": [
                false,
                false
            ],
            "specialReelsSymbols": [
                "X",
                "X"
            ],
            "mysterySymbols": [
                [
                    "X",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "X",
                    "X"
                ]
            ],
            "stickyFires": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "stickyFiresPrev": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "stickyScatter2": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "fireFrameSymbolSize": [
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    2,
                    0
                ],
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    0
                ],
                [
                    1,
                    1,
                    1
                ]
            ],
            "brokeTheBank": false,
            "isDeadFeatureTriggered": false,
            "stickyDeadSymCounter": {},
            "stickyDeadSymCounterNextSpin": {},
            "isSuperXways": false,
            "totalSplits": 0,
            "firstS2FeatureTriggered": [],
            "secondS2FeatureTriggered": [],
            "firstS2FeatureSize": [],
            "secondS2FeatureSize": [],
            "finalEvaluatedArea": [
                [
                    [
                        {
                            "name": "L3",
                            "size": 1,
                            "wasDead": false,
                            "multiplier": 1,
                            "multiplierOccurrence": 0
                        }
                    ],
                    [
                        {
                            "name": "L5",
                            "size": 1,
                            "wasDead": false,
                            "multiplier": 1,
                            "multiplierOccurrence": 0
                        }
                    ],
                    [
                        {
                            "name": "M4",
                            "size": 1,
                            "wasDead": false,
                            "multiplier": 1,
                            "multiplierOccurrence": 0
                        }
                    ]
                ],
                [
                    [
                        {
                            "name": "L2",
                            "size": 1,
                            "wasDead": false,
                            "multiplier": 1,
                            "multiplierOccurrence": 0
                        }
                    ],
                    [
                        {
                            "name": "L4",
                            "size": 2,
                            "wasDead": false,
                            "multiplier": 1,
                            "multiplierOccurrence": 0
                        }
                    ],
                    [
                        {
                            "name": "X",
                            "size": 0,
                            "wasDead": false,
                            "multiplier": 1,
                            "multiplierOccurrence": 0
                        }
                    ]
                ],
                [
                    [
                        {
                            "name": "L3",
                            "size": 1,
                            "wasDead": false,
                            "multiplier": 1,
                            "multiplierOccurrence": 0
                        }
                    ],
                    [
                        {
                            "name": "M4",
                            "size": 1,
                            "wasDead": false,
                            "multiplier": 1,
                            "multiplierOccurrence": 0
                        }
                    ],
                    [
                        {
                            "name": "L4",
                            "size": 1,
                            "wasDead": false,
                            "multiplier": 1,
                            "multiplierOccurrence": 0
                        }
                    ]
                ],
                [
                    [
                        {
                            "name": "L3",
                            "size": 1,
                            "wasDead": false,
                            "multiplier": 1,
                            "multiplierOccurrence": 0
                        }
                    ],
                    [
                        {
                            "name": "L2",
                            "size": 1,
                            "wasDead": false,
                            "multiplier": 1,
                            "multiplierOccurrence": 0
                        }
                    ],
                    [
                        {
                            "name": "X",
                            "size": 0,
                            "wasDead": false,
                            "multiplier": 1,
                            "multiplierOccurrence": 0
                        }
                    ]
                ],
                [
                    [
                        {
                            "name": "L3",
                            "size": 1,
                            "wasDead": false,
                            "multiplier": 1,
                            "multiplierOccurrence": 0
                        }
                    ],
                    [
                        {
                            "name": "L4",
                            "size": 1,
                            "wasDead": false,
                            "multiplier": 1,
                            "multiplierOccurrence": 0
                        }
                    ],
                    [
                        {
                            "name": "L5",
                            "size": 1,
                            "wasDead": false,
                            "multiplier": 1,
                            "multiplierOccurrence": 0
                        }
                    ]
                ]
            ],
            "wasFeatureBuy": false
        };
    }

    public getPaytable(): Promise<string> {
        const data = {
            replaceWincapInfo: Mental.apiPlugin.gameClientConfiguration.replaceWincapInfo,
            showLowProbabilityGfx: Mental.apiPlugin.gameClientConfiguration.showLowProbabilityGfx,
            isNJServer: !!(Mental.apiPlugin.options && Mental.apiPlugin.options.game && Mental.apiPlugin.options.game.indexOf("NJ") > -1),
            isJurisdictionUSPAnNJ: Mental.apiPlugin.gameClientConfiguration.jurisdictionName === "US-PA" && !!(Mental.apiPlugin.options && Mental.apiPlugin.options.game && Mental.apiPlugin.options.game.indexOf("NJ") > -1),
            imagePath: "screens/images/",
            showMultipliersInfo:Mental.apiPlugin.gameClientConfiguration.showMultipliersInfo,
            replaceWordFree: Mental.apiPlugin.gameClientConfiguration.replaceWordFree,
        };

        if (Mental.skinner.skinId != undefined){
            data.imagePath = `../resources/images/${Mental.skinner.skinId}/`;
        }

        return super.getPaytable().then((value: string) => {
            return Mental.apiPlugin.translations.render(value, data);
        });
    }

    public static skinName():string|undefined{
        return Mental.skinner.skinId;
    }

}